<template>
    <div class="page-wrapper bg-white radius-lg margin-left-sm flex flex-direction">
        <div class="tabs-container flex align-center">
            <div v-for="(item,index) in menus" :key="index"
                 :class="[{active:curTab === item.value},{disabled:detail.check_status === 0 && index > 0 }]" class="tab" @click="tabChange(item,index)">{{ item.label }}
            </div>
        </div>
        <div class="padding flex-sub flex flex-direction">
            <project-post v-if="curTab === 0" :detail="detail" :pid="pid" :readonly="readonly" @watchState="watchState"></project-post>
            <post-summary key="1" v-if="curTab === 1" :pid="pid" :type="1" :readonly="false"></post-summary>
            <post-summary key="2" v-if="curTab === 2" :pid="pid" :type="2" :readonly="false"></post-summary>
            <post-outcome v-if="curTab === 3" :pid="pid" :readonly="false"></post-outcome>
        </div>
    </div>
</template>

<script>
import {post_project_menus} from "@/utils/const";
import {getProjectDetail} from "@/api";
import ProjectPost from "@/views/web/staff/components/post/ProjectPost";
import PostSummary from "@/views/web/staff/components/post/PostSummary";
import PostOutcome from "@/views/web/staff/components/post/PostOutcome";

export default {
    name: "post",
    components: {PostOutcome, PostSummary, ProjectPost},
    data() {
        return {
            pid: 0,
            title: '项目结项',
            menus: post_project_menus,
            curTab: 0,
            detail: '',
            readonly: false
        }
    },
    created() {
        this.pid = Number(this.$route.params.id || 0)
        this.curTab = Number(this.$route.params.menu || 0)
        if (this.pid) {
            this.init()
        } else {
            this.$emit('setIndex', [1,0], this.title, true)
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async init() {
            let _data = await getProjectDetail(this.pid)
            this.title = _data.data.p_name
            this.detail = _data.data
            this.readonly = !_data.data.is_operation
            this.$emit('setIndex', 0, `${_data.data.p_name}项目结项`, true)
        },
        tabChange(item, index) {
            if (this.detail.check_status === 0 && index !== 0) return
            this.curTab = item.value
        },
        watchState(data) {
            if (data) this.init()
        }
    }

}
</script>

<style lang="scss" scoped>
.page-wrapper {
}
</style>
